import { Icon } from "@/components/Primitives"
import { CheckCircle2 } from "lucide-react"

interface PasswordRequirementsProps {
  password: string
  validation: boolean[]
  requirements: { label: string }[]
}

export function PasswordRequirements({
  validation,
  requirements,
}: PasswordRequirementsProps) {
  return (
    <ul className="mt-2 mb-0 pl-2 space-y-2">
      {requirements.map((req, idx) => (
        <li
          key={req.label}
          className={`flex items-center gap-2 text-base ${
            validation[idx] ? "text-green-800" : "text-gray-500"
          }`}
        >
          {validation[idx] ? (
            <Icon
              icon={CheckCircle2}
              className="w-4 h-4 text-green-800 fill-current stroke-white"
            />
          ) : (
            <div className="w-4 h-4 rounded-full border-2 border-gray-400" />
          )}
          <span>{req.label}</span>
        </li>
      ))}
    </ul>
  )
}
